export const MILESTONE_KEY = {
	INSPECTION: "INSPECTION",
	ESTIMATE: "ESTIMATE",
	PERMIT_SUBMISSION: "PERMIT_SUBMISSION",
	MATERIAL_PURCHASE: "MATERIAL_PURCHASE",
	JOB_START: "JOB_START",
	ESTIMATED_COMPLETION: "ESTIMATED_COMPLETION",
	COMPLETION: "COMPLETION",
} as const;
